import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Utils} from "@amlCore/utils";
import {FromuSubject} from "../../../model/fromu";
import {RegistriesService} from "../../../service";
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-registry-fromu-form',
  templateUrl: './fromu.component.html'
})
export class FromuComponent implements OnInit {
  item = {} as FromuSubject;

  @Input() id = null;
  @Input() isModal = false;
  @Output() startLoading: any = new EventEmitter<boolean>();
  @Output() finishLoading: any = new EventEmitter<boolean>();
  constructor(private regSrv: RegistriesService,
              private route: ActivatedRoute,
              private _activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.id) {
      this.startLoading.emit(true);
      this.startLoading.complete();
      this.loadSubject(this.id);
    } else {
      this.route.params.subscribe(params => {
        Utils.scrollTopSmooth();
        this.id = params.id;
        this.loadSubject(this.id);
      });
    }
  }

  loadSubject(id: string) {
    this.regSrv.getFromuById(id).subscribe((data: FromuSubject) => {
      this.item = data;
      this.finishLoading.emit(false);
      this.finishLoading.complete();
    });
  }

  closeModal() {
    this._activeModal.dismiss(false);
  }
}
